var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49845 3.50317H2.88854C2.38767 3.50317 1.90731 3.70214 1.55314 4.05632C1.19897 4.41049 1 4.89084 1 5.39172V18.6115C1 19.1124 1.19897 19.5927 1.55314 19.9469C1.90731 20.3011 2.38767 20.5001 2.88854 20.5001H16.1084C16.6092 20.5001 17.0896 20.3011 17.4438 19.9469C17.7979 19.5927 17.9969 19.1124 17.9969 18.6115V12.0016",
    stroke: "#25282B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5809 2.08669C16.9565 1.71104 17.466 1.5 17.9973 1.5C18.5285 1.5 19.038 1.71104 19.4137 2.08669C19.7893 2.46235 20.0004 2.97185 20.0004 3.5031C20.0004 4.03436 19.7893 4.54385 19.4137 4.91951L10.4431 13.8901L6.66602 14.8344L7.61029 11.0573L16.5809 2.08669Z",
    stroke: "#25282B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.3a8a041986616ac181965488ff88e9c2.svg";
export { ForwardRef as ReactComponent };